import {ModelBase, NeoModel} from '@singularsystems/neo-core';

@NeoModel
export default class MultiCheckBoxWithOtherStringAnswerType extends ModelBase {

    // Properties
    public selectedValues : string[] = []
    public otherSelected : boolean = false
    public otherString: string = ""
}